import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";

export default function EditButton({ uri }) {
  const {
    t,
  } = useTranslation();

  const history = useHistory();
  const style = {
    padding: "2px 5px",
  };
  return (
    <div className="float-right">
      <Button
        onClick={() => {
          history.push(uri);
        }}
        variant="warning"
        size="md"
        className="text-warning btn-link"
        style={style}
        title={t("common.actions.edit")}
      >
        <i className="fa fa-edit" />
      </Button>
    </div>
  );
}
